import { XMarkIcon } from "@heroicons/react/24/outline";
import { classNames } from "../utils";

interface LargeToastProps {
  state: {
    icon?: JSX.Element;
    title?: string;
    message?: string;
    isVisible: boolean;
    position?: string;
  };
  onHide: () => void;
}

const LargeToast = ({ state, onHide }: LargeToastProps) => {
  if (!state.isVisible) return null;

  return (
    <div
      className={classNames(
        "fixed right-10 w-[37rem] bg-white border rounded-lg p-6 shadow-black",
        state.position === "bottom" ? "bottom-24" : "",
        state.position === "top" ? "top-24" : "",
        !state.position ? "bottom-24" : ""
      )}
    >
      <div>
        <XMarkIcon
          className="absolute top-2 right-2 w-7 cursor-pointer text-gray-500 hover:bg-gray-100 rounded-full p-1"
          onClick={onHide}
        />
      </div>
      <div className="flex gap-4">
        <div>{state.icon}</div>
        <div>
          {state.title && <div className="text-xl">{state.title}</div>}
          <p className="pt-2 text-gray-500">{state?.message}</p>
        </div>
      </div>
    </div>
  );
};

export default LargeToast;
